import {ITokenEmission} from '../../models/Emission';

export const FETCH_EMISSIONS = 'FETCH_EMISSIONS';
export const FETCH_EMISSIONS_SUCCESS = 'FETCH_EMISSIONS_SUCCESS';
export const FETCH_EMISSIONS_ERROR = 'FETCH_EMISSIONS_ERROR';

export const UPDATE_EMISSION = 'UPDATE_EMISSION';
export const UPDATE_EMISSION_SUCCESS = 'UPDATE_EMISSION_SUCCESS';
export const UPDATE_EMISSION_ERROR = 'UPDATE_EMISSION_ERROR';

export const ADD_EMISSION = 'ADD_EMISSION';

export enum EmissionType {
  BURN = 'burn',
  MINT = 'mint',
}

export interface FetchEmissions {
  type: typeof FETCH_EMISSIONS;
}

export interface FetchEmissionsSuccess {
  type: typeof FETCH_EMISSIONS_SUCCESS;
  payload: ITokenEmission[];
}

export interface FetchEmissionsError {
  type: typeof FETCH_EMISSIONS_ERROR;
}

export interface UpdateEmission {
  type: typeof UPDATE_EMISSION;
  payload: EmissionType;
}

export interface UpdateEmissionSuccess {
  type: typeof UPDATE_EMISSION_SUCCESS;
  payload: EmissionType;
}

export interface UpdateEmissionError {
  type: typeof UPDATE_EMISSION_ERROR;
  payload: EmissionType;
}

export interface AddEmission {
  type: typeof ADD_EMISSION;
  payload: ITokenEmission;
}

export type TokenEmissionsActionTypes =
  | FetchEmissions
  | FetchEmissionsSuccess
  | FetchEmissionsError
  | UpdateEmission
  | UpdateEmissionSuccess
  | UpdateEmissionError
  | AddEmission;
